/**
 * Created by huangzhangshu on 2017/12/28
 */
import React, { Component } from 'react';
import { Icon } from 'antd';
import './style/index.less';

const ICONX_PREFIX = 'icon iconfont icon';

interface StringMapInterface  {
  [type: string]: string;
}

const mapTypes: StringMapInterface = {
  '-shezhi': '-setup',
}

export interface IconProps {
  // 图标类别
  type: string;
  style?: React.CSSProperties;
}

export default class IconX extends Component<IconProps> {

  // 绘制蚂蚁金服icon
  renderForIcon(props: any): React.ReactNode {
    // @ts-ignore
    return <Icon  {...props} />;
  }

  // 绘制自定义阿里矢量图
  renderForIconX(type: string, props: any): React.ReactNode {
    const { className = '' } = props;
    const iconClassName = `${ICONX_PREFIX + (mapTypes[type] || type)} ${className}`;
    return <i {...props} className={iconClassName} />
  }


  render() {
    const { type = '' } = this.props;
    if (type.startsWith('-')) return this.renderForIconX(type, this.props);
    return this.renderForIcon(this.props);
  }
}
